import { Module } from "vuex";
import { RootState } from "@/store";

interface State {
  totalCount: number;
  datasetOrderCount: number;
  apiOrderCount: number;
  orderNoticeList: string[];
}

const store: Module<State, RootState> = {
  namespaced: true,
  state: () => ({
    totalCount: 0,
    datasetOrderCount: 0,
    apiOrderCount: 0,
    orderNoticeList: [],
  }),

  mutations: {
    setUnreadCounts(state: State, payload: State) {
      state.totalCount = payload.totalCount;
      state.datasetOrderCount = payload.datasetOrderCount;
      state.apiOrderCount = payload.apiOrderCount;
      state.orderNoticeList = payload.orderNoticeList;
    },
  },
};

export default store;
